<script>

    import { toast } from 'bulma-toast'

    import StatisticsQuotationsService from '../$services/statistics.quotations.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import DateTime from './component.quotations.datetime.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'

    // columnas ordenables, en el orden en que aparecen después de usuario y correo
    const sortable = [
        { key: 'generated', label: 'Guías generadas' },
        { key: 'quotations', label: '# Cotizaciones' },
        { key: 'lastLogin', label: 'Último ingreso' },
        { key: 'lastQuotation', label: 'Última cotización' },
    ]

    let find = ''
    let page = 0
    let sort = 'lastLogin'
    let order = 'desc'
    let metadata = {}
    let users = []
    let summary = null
    let loading = false
    let seq = 0

    load()

    function search() { page = 0; load() }

    // una columna nueva empieza de mayor a menor; al repetirla se invierte el orden
    function sortBy(key) {
        order = sort === key && order === 'desc' ? 'asc' : 'desc'
        sort = key
        page = 0
        load()
    }

    async function load() {
        const id = ++seq

        loading = true
        const res = await StatisticsQuotationsService.getUsers({
            page,
            find: find || undefined,
            sort,
            order,
        })

        // si cambió la búsqueda, el orden o la página mientras cargaba, esta respuesta ya no aplica
        if (id !== seq) return

        loading = false
        if (!res?.success) {
            users = []
            return toast({ message: res?.error?.message || 'No se pudo cargar la lista de usuarios', type: 'is-danger' })
        }
        summary = res.data.summary
        users = res.data.users
        metadata = res.data.metadata
    }

    function count(value) { return summary ? NumeralMethods.number(value) : '—' }

</script>

<style>
    .caption { margin: 0 0 1.25rem; font-size: 0.85rem; color: #6b7280; }
    .user-name { font-weight: 600; color: #1a1a1a; }
    .muted { font-size: 0.8rem; color: #9e9e9e; }
    .nowrap { white-space: nowrap; }

    .sort {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        padding: 0;
        border: 0;
        background: none;
        font: inherit;
        color: inherit;
        letter-spacing: inherit;
        text-transform: inherit;
        cursor: pointer;
    }
    .sort.is-sorted { color: #1a1a1a; }
    .sort:not(.is-sorted) i { opacity: 0.35; }
</style>

<div class="columns is-multiline">
    <div class="column is-4">
        <StatsCard icon="fas fa-users" title="Usuarios totales" value={ count(summary?.total) } change={ null } />
    </div>
    <div class="column is-4">
        <StatsCard icon="fas fa-user-check" title="Clientes activos · 30 días" value={ count(summary?.active) } change={ null } />
    </div>
    <div class="column is-4">
        <StatsCard icon="fas fa-user-slash" title="Clientes inactivos · 30 días" value={ count(summary?.inactive) } change={ null } />
    </div>
</div>

<p class="caption">
    Activo: ingresó y generó al menos una guía en los últimos 30 días. Inactivo: no ingresó y/o no generó guía en ese periodo.
</p>

<Table
    items={ users.length }
    total={ metadata.total }
    { loading }
    skeletonCols={7}
    bind:metadata
    bind:page
    on:change={ load }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ find } placeholder="Buscar por nombre o correo" on:enter={ search } />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>Usuario</th>
            <th>Correo</th>
            {#each sortable as column (column.key)}
                <th aria-sort={ sort === column.key ? (order === 'asc' ? 'ascending' : 'descending') : 'none' }>
                    <button type="button" class="sort" class:is-sorted={ sort === column.key } on:click={ () => sortBy(column.key) }>
                        <span>{ column.label }</span>
                        <i class="fas { sort === column.key ? (order === 'asc' ? 'fa-sort-up' : 'fa-sort-down') : 'fa-sort' }"></i>
                    </button>
                </th>
            {/each}
            <th>Fecha de registro</th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each users as item (item._id)}
            <tr>
                <td>
                    {#if item.name}
                        <span class="user-name">{ item.name }</span>
                    {:else}
                        <span class="muted">Sin nombre</span>
                    {/if}
                </td>
                <td>{ item.email }</td>
                <td>{ NumeralMethods.number(item.generated) }</td>
                <td>{ NumeralMethods.number(item.quotations) }</td>
                <td class="nowrap"><DateTime value={ item.lastLogin } /></td>
                <td class="nowrap"><DateTime value={ item.lastQuotation } /></td>
                <td class="nowrap"><DateTime value={ item.created } /></td>
            </tr>
        {/each}
    </tbody>
</Table>
